module.exports = __webpack_public_path__ + "static/media/3DPPA24.3043ce74.jpg";